// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width: 550px){.tournament-card__participant-link{padding:7px 14px !important}}.tournament-card__content-top{display:flex;justify-content:space-between}.tournament-card__banner{max-width:130px;margin-top:24px;margin-right:22px}.tournament-card__banner img{width:130px;height:fit-content}@media(max-width: 550px){.tournament-card__banner{max-width:90px;margin-top:14px}.tournament-card__banner img{width:90px;height:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
